import React from 'react'
import { Box } from '@chakra-ui/react'
import PropTypes from 'prop-types'

VerticalLine.propTypes = {
  indent: PropTypes.number,
}

export function VerticalLine({ indent = 0 }) {
  return (
    <Box
      position="absolute"
      zIndex={0}
      top={indent > 0 ? 4 : 5}
      left={1 - (indent - 1) * 4}
    >
      <svg
        width={2}
        height="100%"
      >
        <line
          x1={0}
          y1={0}
          x2={0}
          y2={indent === 0 ? 39 : 30}
          stroke="rgba(255, 255, 255, .3)"
        />
      </svg>
    </Box>
  )
}
